import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class DataValidationLookup extends ModelBase {
  public validationMessages: string = "";
}